import React, { useState,useContext } from "react";
import { Auth } from "aws-amplify";
import { Redirect } from "react-router";
import {PAGE} from "../../constants"
import {PageContext} from '../../PageContext';
import {setLoginMessage} from "../../apis/sharedata"
import {confirmForgotPassword} from "../../apis/auth.js"


export function VerificationCodeForResetPassword(props) {
    const [verificationCode,setVerificationCode] = useState("");
    const [isVerificationSuccess,setIsVerificationSuccess] = useState("");
    const [newPassword,setNewPassword] = useState("")
    const [newRePassword,setNewRePassword] = useState("")
    const [formError,setFormError] = useState("");
    
    const {page, setPage} = useContext(PageContext);
    



    var email = props.email;

    async function onVerificationCode(event) {
        event.preventDefault();
        console.log("Inside onVerification");
        await confirmForgotPassword(verificationCode,email,newPassword)
        .then((res)=>  {
            return res.json()
        })
        .then((data)=>{
            console.log("response "+data)
            setIsVerificationSuccess(true);
        })
        .catch((err)=>{
            console.error(err.message);
            setFormError(err.message);
            throw err;
        })
       
        // await Auth.forgotPasswordSubmit(email, verificationCode,newPassword)
        // .then((res) => {
        //         if(res === "SUCCESS"){
        //             setIsVerificationSuccess(true);
        //         }else{
        //             console.error("forgotPasswordSubmit failed");
        //             throw new Error("forgotPasswordSubmit failed");
        //         }
        //     }
        // )
        // .catch((err)=>{
        //     console.error(err.message);
        //     setFormError(err.message);
        // })
        
        


    }

    if(isVerificationSuccess){
        
        setLoginMessage("Password is reset. Please log with your password");
        setPage(PAGE.LOGIN);
        // return (

        //     <Redirect to={{pathname:"/",state: {message: "Password is reset. Please log with your password"}}} />        
        // );
    }

    return (
        <div className="topcontainer-signup" >
            <h1>Verification code</h1>
            <p>A verfication code is sent to your email address. Please enter the Verification code to complete the password reset  process</p>
            {formError && <p style={{color:"red"}}>{formError}</p>}
                    
            <hr />
            <form onSubmit={onVerificationCode}>
                <input type="text" value={verificationCode} className="ipt ipc" onChange={(event) => setVerificationCode(event.target.value)} placeholder="Enter Verification code" name="verificationcode" required />
                <input type="password" value={newPassword} className="ipt ipc" onChange={(event) => setNewPassword(event.target.value)} placeholder="Enter new Password " name="newpassword" required />
                <input type="password" value={newRePassword} className="ipt ipc" onChange={(event) => setNewRePassword(event.target.value)} placeholder="Enter new Password again" name="newpassword" required />
                <button type="submit" className="ips ipc">Submit</button>
            </form>
        </div>
    );
}